import React, { useCallback } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import CampaignAssistantChat from "./CampaignAssistantChat";

/**
 * Campaign assistant chat — fills the main content column only (sidebar unchanged).
 */
export default function CampaignAssistantPage() {
  const onCampaignCreated = useCallback(() => {
    toast.success("Campaña creada");
  }, []);

  return (
    <div className="flex flex-col h-full min-h-0 overflow-hidden bg-white rounded-lg border shadow-sm">
      <div className="shrink-0 border-b px-4 py-3 flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-teal-600 shrink-0" />
        <h1 className="text-base font-semibold text-gray-900 truncate">Asistente Reveca</h1>
      </div>
      <div className="flex-1 min-h-0 w-full px-4 pb-5 pt-2 flex flex-col overflow-hidden bg-gray-50">
        <CampaignAssistantChat
          active
          fullPage
          onCampaignCreated={onCampaignCreated}
        />
      </div>
    </div>
  );
}
